module.exports = __webpack_public_path__ + "static/media/change_photo.35366594.svg";


//////////////////
// WEBPACK FOOTER
// ./src/statics/images/change_photo.svg
// module id = ./src/statics/images/change_photo.svg
// module chunks = 0